import React, { useState } from "react";

function App() {

  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const API = process.env.REACT_APP_API_URL;

  const handleFileChange = (e) => {

    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    setFile(selectedFile);
    setPreview(URL.createObjectURL(selectedFile));
    setResult(null);
  };

  const handlePredict = async () => {

    if (!file) {
      alert("Please upload an image first");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    setLoading(true);

    try {

      const response = await fetch(`${API}/predict`, {
        method: "POST",
        body: formData
      });

      const data = await response.json();
      setResult(data);

    } catch (error) {

      console.error(error);
      alert("Prediction failed");

    }

    setLoading(false);
  };

  return (

    <div style={{ textAlign: "center", marginTop: "60px", fontFamily: "Arial" }}>

      <h1>Potato Disease Detector</h1>

      <p>Upload a potato leaf image</p>

      <input type="file" onChange={handleFileChange} />

      {preview && (
        <div style={{ marginTop: "20px" }}>
          <img
            src={preview}
            alt="preview"
            style={{ width: "250px", borderRadius: "10px" }}
          />
        </div>
      )}

      <br />

      <button
        onClick={handlePredict}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          cursor: "pointer"
        }}
      >
        Predict
      </button>

      {loading && <p> Analyzing image...</p>}

      {result && (

        <div style={{ marginTop: "30px" }}>

          <h2>Prediction</h2>

          <p><b>Disease:</b> {result.class}</p>

          <p>
            <b>Confidence:</b> {(result.confidence * 100).toFixed(2)}%
          </p>

        </div>

      )}

    </div>

  );
}

export default App;